// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"611":"5501c2ad","661":"e803e2ad"}[chunkId] + ".chunk.js";
};